"use strict";
/**
 * 行情字段配置
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.transTradeTime = exports.formatNumMaxWidth = exports.quoteItem = exports.ListItemConfig = exports.QuoteItem = void 0;
var react_1 = __importDefault(require("react"));
/**
 * 行情字段
 */
var QuoteItem;
(function (QuoteItem) {
    QuoteItem[QuoteItem["\u540D\u79F0"] = 0] = "\u540D\u79F0";
    QuoteItem[QuoteItem["\u5E02\u573A"] = 1] = "\u5E02\u573A";
    QuoteItem[QuoteItem["\u8BC1\u5238\u7C7B\u578B"] = 2] = "\u8BC1\u5238\u7C7B\u578B";
    QuoteItem[QuoteItem["\u4EE3\u7801"] = 3] = "\u4EE3\u7801";
    QuoteItem[QuoteItem["\u4EE3\u7801\u5E26\u94FE\u63A5"] = 4] = "\u4EE3\u7801\u5E26\u94FE\u63A5";
    QuoteItem[QuoteItem["\u884C\u60C5\u4EE3\u7801"] = 5] = "\u884C\u60C5\u4EE3\u7801";
    QuoteItem[QuoteItem["\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5"] = 6] = "\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5";
    QuoteItem[QuoteItem["\u677F\u5757\u94FE\u63A5"] = 7] = "\u677F\u5757\u94FE\u63A5";
    QuoteItem[QuoteItem["\u65B0\u4E09\u677F\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5"] = 8] = "\u65B0\u4E09\u677F\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5";
    QuoteItem[QuoteItem["\u6700\u65B0\u4EF7"] = 9] = "\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["\u6DA8\u8DCC\u5E45"] = 10] = "\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u6DA8\u8DCC\u989D"] = 11] = "\u6DA8\u8DCC\u989D";
    QuoteItem[QuoteItem["\u4ECA\u5F00\u4EF7"] = 12] = "\u4ECA\u5F00\u4EF7";
    QuoteItem[QuoteItem["\u4ECA\u5F00\u4EF7\u7528\u6628\u7ED3\u8BA1\u7B97"] = 13] = "\u4ECA\u5F00\u4EF7\u7528\u6628\u7ED3\u8BA1\u7B97";
    QuoteItem[QuoteItem["\u6700\u9AD8\u4EF7"] = 14] = "\u6700\u9AD8\u4EF7";
    QuoteItem[QuoteItem["\u6700\u9AD8\u4EF7\u7528\u6628\u7ED3\u8BA1\u7B97"] = 15] = "\u6700\u9AD8\u4EF7\u7528\u6628\u7ED3\u8BA1\u7B97";
    QuoteItem[QuoteItem["\u6700\u4F4E\u4EF7"] = 16] = "\u6700\u4F4E\u4EF7";
    QuoteItem[QuoteItem["\u6700\u4F4E\u4EF7\u7528\u6628\u7ED3\u8BA1\u7B97"] = 17] = "\u6700\u4F4E\u4EF7\u7528\u6628\u7ED3\u8BA1\u7B97";
    QuoteItem[QuoteItem["\u6628\u6536\u4EF7"] = 18] = "\u6628\u6536\u4EF7";
    QuoteItem[QuoteItem["\u6628\u7ED3"] = 19] = "\u6628\u7ED3";
    QuoteItem[QuoteItem["\u603B\u5E02\u503C"] = 20] = "\u603B\u5E02\u503C";
    QuoteItem[QuoteItem["\u6D41\u901A\u5E02\u503C"] = 21] = "\u6D41\u901A\u5E02\u503C";
    QuoteItem[QuoteItem["\u51C0\u5229\u6DA6"] = 22] = "\u51C0\u5229\u6DA6";
    QuoteItem[QuoteItem["\u5E02\u76C8\u7387\u52A8\u6001"] = 23] = "\u5E02\u76C8\u7387\u52A8\u6001";
    QuoteItem[QuoteItem["\u5E02\u76C8\u7387TTM"] = 24] = "\u5E02\u76C8\u7387TTM";
    QuoteItem[QuoteItem["\u6210\u4EA4\u91CF"] = 25] = "\u6210\u4EA4\u91CF";
    QuoteItem[QuoteItem["\u6210\u4EA4\u989D"] = 26] = "\u6210\u4EA4\u989D";
    QuoteItem[QuoteItem["\u632F\u5E45"] = 27] = "\u632F\u5E45";
    QuoteItem[QuoteItem["\u91CF\u6BD4"] = 28] = "\u91CF\u6BD4";
    QuoteItem[QuoteItem["\u6362\u624B\u7387"] = 29] = "\u6362\u624B\u7387";
    QuoteItem[QuoteItem["\u5E02\u51C0\u7387"] = 30] = "\u5E02\u51C0\u7387";
    QuoteItem[QuoteItem["\u59D4\u6BD4"] = 31] = "\u59D4\u6BD4";
    QuoteItem[QuoteItem["\u4EA4\u6613\u65F6\u95F4"] = 32] = "\u4EA4\u6613\u65F6\u95F4";
    QuoteItem[QuoteItem["\u5185\u76D8_\u5356\u76D8"] = 33] = "\u5185\u76D8_\u5356\u76D8";
    QuoteItem[QuoteItem["\u5916\u76D8_\u4E70\u76D8"] = 34] = "\u5916\u76D8_\u4E70\u76D8";
    QuoteItem[QuoteItem["\u6301\u4ED3\u91CF"] = 35] = "\u6301\u4ED3\u91CF";
    QuoteItem[QuoteItem["\u4E70\u91CF"] = 36] = "\u4E70\u91CF";
    QuoteItem[QuoteItem["\u5356\u91CF"] = 37] = "\u5356\u91CF";
    QuoteItem[QuoteItem["\u4E70\u5165\u4EF7\u6216\u4E70\u4E00\u4EF7"] = 38] = "\u4E70\u5165\u4EF7\u6216\u4E70\u4E00\u4EF7";
    QuoteItem[QuoteItem["\u4E70\u4E8C\u4EF7"] = 39] = "\u4E70\u4E8C\u4EF7";
    QuoteItem[QuoteItem["\u5356\u51FA\u4EF7\u6216\u5356\u4E00\u4EF7"] = 40] = "\u5356\u51FA\u4EF7\u6216\u5356\u4E00\u4EF7";
    QuoteItem[QuoteItem["\u5356\u4E8C\u4EF7"] = 41] = "\u5356\u4E8C\u4EF7";
    QuoteItem[QuoteItem["\u4E3B\u529B\u51C0\u5360\u6BD4"] = 42] = "\u4E3B\u529B\u51C0\u5360\u6BD4";
    QuoteItem[QuoteItem["\u4E3B\u529B\u51C0\u5360\u6BD4_\u6392\u540D"] = 43] = "\u4E3B\u529B\u51C0\u5360\u6BD4_\u6392\u540D";
    QuoteItem[QuoteItem["\u4E3B\u529B\u51C0\u5360\u6BD4_\u6392\u540D\u53D8\u5316"] = 44] = "\u4E3B\u529B\u51C0\u5360\u6BD4_\u6392\u540D\u53D8\u5316";
    QuoteItem[QuoteItem["\u6DA8\u8DCC\u5E45_5\u5206\u949F"] = 45] = "\u6DA8\u8DCC\u5E45_5\u5206\u949F";
    QuoteItem[QuoteItem["\u6DA8\u8DCC\u5E45_60\u65E5"] = 46] = "\u6DA8\u8DCC\u5E45_60\u65E5";
    QuoteItem[QuoteItem["\u5E74\u521D\u81F3\u4ECA\u6DA8\u8DCC\u5E45"] = 47] = "\u5E74\u521D\u81F3\u4ECA\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u6DA8\u901F_3\u5206\u949F"] = 48] = "\u6DA8\u901F_3\u5206\u949F";
    QuoteItem[QuoteItem["\u4E3B\u529B\u51C0\u6D41\u5165"] = 49] = "\u4E3B\u529B\u51C0\u6D41\u5165";
    QuoteItem[QuoteItem["\u677F\u5757\u9886\u6DA8\u80A1"] = 50] = "\u677F\u5757\u9886\u6DA8\u80A1";
    QuoteItem[QuoteItem["\u677F\u5757\u9886\u6DA8\u80A1\u6DA8\u8DCC\u5E45"] = 51] = "\u677F\u5757\u9886\u6DA8\u80A1\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u677F\u5757\u9886\u8DCC\u80A1"] = 52] = "\u677F\u5757\u9886\u8DCC\u80A1";
    QuoteItem[QuoteItem["\u677F\u5757\u9886\u8DCC\u80A1\u6DA8\u8DCC\u5E45"] = 53] = "\u677F\u5757\u9886\u8DCC\u80A1\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u677F\u5757\u8D44\u91D1\u6D41\u5165\u6700\u5927\u80A1"] = 54] = "\u677F\u5757\u8D44\u91D1\u6D41\u5165\u6700\u5927\u80A1";
    QuoteItem[QuoteItem["\u6DA8\u8DCC\u5BB6\u6570"] = 55] = "\u6DA8\u8DCC\u5BB6\u6570";
    QuoteItem[QuoteItem["\u677F\u5757\u6216\u6307\u6570\u4E0A\u6DA8\u6570\u91CF"] = 56] = "\u677F\u5757\u6216\u6307\u6570\u4E0A\u6DA8\u6570\u91CF";
    QuoteItem[QuoteItem["\u677F\u5757\u6216\u6307\u6570\u4E0B\u8DCC\u6570\u91CF"] = 57] = "\u677F\u5757\u6216\u6307\u6570\u4E0B\u8DCC\u6570\u91CF";
    QuoteItem[QuoteItem["\u677F\u5757\u6216\u6307\u6570\u5E73\u6570\u91CF"] = 58] = "\u677F\u5757\u6216\u6307\u6570\u5E73\u6570\u91CF";
    QuoteItem[QuoteItem["\u4E0A\u5E02\u65E5\u671F"] = 59] = "\u4E0A\u5E02\u65E5\u671F";
    QuoteItem[QuoteItem["AB\u80A1\u5BF9\u5E94\u7684\u5E02\u573A"] = 60] = "AB\u80A1\u5BF9\u5E94\u7684\u5E02\u573A";
    QuoteItem[QuoteItem["AB\u80A1\u5BF9\u5E94\u7684\u4EE3\u7801"] = 61] = "AB\u80A1\u5BF9\u5E94\u7684\u4EE3\u7801";
    QuoteItem[QuoteItem["AB\u80A1\u5BF9\u5E94\u7684\u540D\u79F0"] = 62] = "AB\u80A1\u5BF9\u5E94\u7684\u540D\u79F0";
    QuoteItem[QuoteItem["AB\u80A1\u5BF9\u5E94\u7684\u6700\u65B0\u4EF7"] = 63] = "AB\u80A1\u5BF9\u5E94\u7684\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["AB\u80A1\u5BF9\u5E94\u7684\u6DA8\u8DCC\u5E45"] = 64] = "AB\u80A1\u5BF9\u5E94\u7684\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["AB\u80A1\u6BD4\u4EF7"] = 65] = "AB\u80A1\u6BD4\u4EF7";
    QuoteItem[QuoteItem["H\u80A1\u5BF9\u5E94\u7684A\u80A1\u5E02\u573A"] = 66] = "H\u80A1\u5BF9\u5E94\u7684A\u80A1\u5E02\u573A";
    QuoteItem[QuoteItem["H\u80A1\u5BF9\u5E94\u7684A\u80A1\u4EE3\u7801"] = 67] = "H\u80A1\u5BF9\u5E94\u7684A\u80A1\u4EE3\u7801";
    QuoteItem[QuoteItem["H\u80A1\u5BF9\u5E94\u7684A\u80A1\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5"] = 68] = "H\u80A1\u5BF9\u5E94\u7684A\u80A1\u884C\u60C5\u7EDF\u4E00\u94FE\u63A5";
    QuoteItem[QuoteItem["H\u80A1\u5BF9\u5E94\u7684A\u80A1\u6700\u65B0\u4EF7"] = 69] = "H\u80A1\u5BF9\u5E94\u7684A\u80A1\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["H\u80A1\u5BF9\u5E94\u7684A\u80A1\u6DA8\u8DCC\u5E45"] = 70] = "H\u80A1\u5BF9\u5E94\u7684A\u80A1\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["AH\u80A1\u6BD4\u4EF7"] = 71] = "AH\u80A1\u6BD4\u4EF7";
    QuoteItem[QuoteItem["AH\u80A1\u6EA2\u4EF7"] = 72] = "AH\u80A1\u6EA2\u4EF7";
    QuoteItem[QuoteItem["\u5E26\u4EA4\u6613\u72B6\u6001\u7684\u540D\u79F0"] = 73] = "\u5E26\u4EA4\u6613\u72B6\u6001\u7684\u540D\u79F0";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u4EE3\u7801"] = 74] = "\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u4EE3\u7801";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u540D\u79F0"] = 75] = "\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u540D\u79F0";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u6700\u65B0\u4EF7"] = 76] = "\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u6DA8\u8DCC\u5E45"] = 77] = "\u53EF\u8F6C\u503A\u5BF9\u5E94\u7684\u6B63\u80A1\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u8F6C\u80A1\u4EF7"] = 78] = "\u53EF\u8F6C\u503A\u8F6C\u80A1\u4EF7";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u8F6C\u80A1\u4EF7\u503C"] = 79] = "\u53EF\u8F6C\u503A\u8F6C\u80A1\u4EF7\u503C";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u8F6C\u80A1\u6EA2\u4EF7\u7387"] = 80] = "\u53EF\u8F6C\u503A\u8F6C\u80A1\u6EA2\u4EF7\u7387";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u7EAF\u503A\u6EA2\u4EF7\u7387"] = 81] = "\u53EF\u8F6C\u503A\u7EAF\u503A\u6EA2\u4EF7\u7387";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u56DE\u552E\u89E6\u53D1\u4EF7"] = 82] = "\u53EF\u8F6C\u503A\u56DE\u552E\u89E6\u53D1\u4EF7";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5F3A\u8D4E\u89E6\u53D1\u4EF7"] = 83] = "\u53EF\u8F6C\u503A\u5F3A\u8D4E\u89E6\u53D1\u4EF7";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5230\u671F\u8D4E\u56DE\u4EF7"] = 84] = "\u53EF\u8F6C\u503A\u5230\u671F\u8D4E\u56DE\u4EF7";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u7EAF\u503A\u4EF7\u503C"] = 85] = "\u53EF\u8F6C\u503A\u7EAF\u503A\u4EF7\u503C";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u5F00\u59CB\u8F6C\u80A1\u65E5"] = 86] = "\u53EF\u8F6C\u503A\u5F00\u59CB\u8F6C\u80A1\u65E5";
    QuoteItem[QuoteItem["\u53EF\u8F6C\u503A\u7533\u8D2D\u65E5"] = 87] = "\u53EF\u8F6C\u503A\u7533\u8D2D\u65E5";
    QuoteItem[QuoteItem["ADR\u4EE3\u7801\u5E26\u94FE\u63A5"] = 88] = "ADR\u4EE3\u7801\u5E26\u94FE\u63A5";
    QuoteItem[QuoteItem["ADR\u6536\u5E02\u4EF7"] = 89] = "ADR\u6536\u5E02\u4EF7";
    QuoteItem[QuoteItem["ADR\u6DA8\u8DCC\u989D"] = 90] = "ADR\u6DA8\u8DCC\u989D";
    QuoteItem[QuoteItem["ADR\u6DA8\u8DCC\u5E45"] = 91] = "ADR\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["ADR\u6298\u5408\u6BCF\u80A1\u6E2F\u5143"] = 92] = "ADR\u6298\u5408\u6BCF\u80A1\u6E2F\u5143";
    QuoteItem[QuoteItem["\u671F\u6743\u6700\u65B0\u4EF7"] = 93] = "\u671F\u6743\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["\u671F\u6743\u6807\u7684\u5238\u6700\u65B0\u4EF7"] = 94] = "\u671F\u6743\u6807\u7684\u5238\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["\u671F\u6743\u6DA8\u8DCC\u5E45"] = 95] = "\u671F\u6743\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u671F\u6743\u6DA8\u8DCC\u989D"] = 96] = "\u671F\u6743\u6DA8\u8DCC\u989D";
    QuoteItem[QuoteItem["\u671F\u6743\u884C\u6743\u4EF7"] = 97] = "\u671F\u6743\u884C\u6743\u4EF7";
    QuoteItem[QuoteItem["\u671F\u6743T\u578B\u62A5\u4EF7\u884C\u6743\u4EF7"] = 98] = "\u671F\u6743T\u578B\u62A5\u4EF7\u884C\u6743\u4EF7";
    QuoteItem[QuoteItem["\u671F\u6743\u5269\u4F59\u671F\u9650"] = 99] = "\u671F\u6743\u5269\u4F59\u671F\u9650";
    QuoteItem[QuoteItem["\u671F\u8D27\u65E5\u589E"] = 100] = "\u671F\u8D27\u65E5\u589E";
    QuoteItem[QuoteItem["\u671F\u8D27\u4ECA\u5F00"] = 101] = "\u671F\u8D27\u4ECA\u5F00";
    QuoteItem[QuoteItem["\u671F\u6743\u9690\u542B\u6CE2\u52A8\u7387"] = 102] = "\u671F\u6743\u9690\u542B\u6CE2\u52A8\u7387";
    QuoteItem[QuoteItem["\u671F\u6743\u6298\u6EA2\u4EF7\u7387"] = 103] = "\u671F\u6743\u6298\u6EA2\u4EF7\u7387";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u540D\u79F0"] = 104] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u540D\u79F0";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6700\u65B0\u4EF7"] = 105] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6700\u65B0\u4EF7";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6DA8\u8DCC\u989D"] = 106] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6DA8\u8DCC\u989D";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6DA8\u8DCC\u5E45"] = 107] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6DA8\u8DCC\u5E45";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6210\u4EA4\u91CF"] = 108] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6210\u4EA4\u91CF";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6301\u4ED3\u91CF"] = 109] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6301\u4ED3\u91CF";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u9690\u542B\u6CE2\u52A8\u7387"] = 110] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u9690\u542B\u6CE2\u52A8\u7387";
    QuoteItem[QuoteItem["\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6298\u6EA2\u4EF7\u7387"] = 111] = "\u8BA4\u6CBD\u8BA4\u8D2D\u671F\u6743\u6298\u6EA2\u4EF7\u7387";
})(QuoteItem || (exports.QuoteItem = QuoteItem = {}));
/**
 * 列表行情的字段配置
 */
exports.ListItemConfig = (_a = {},
    _a[QuoteItem.名称] = {
        fid: ['f14'],
        sort: "f14",
        value: function (data) {
            return {
                txt: data.f14,
                html: react_1.default.createElement("span", null, data.f14),
                color: '',
                source: data.f14
            };
        }
    },
    _a[QuoteItem.代码] = {
        fid: ['f12'],
        sort: 'f12',
        value: function (data) {
            return {
                txt: data.f12,
                html: react_1.default.createElement("span", null, data.f12),
                color: '',
                source: data.f12
            };
        }
    },
    _a[QuoteItem.代码带链接] = {
        fid: ['f12', 'f13', 'f14'],
        sort: 'f12',
        value: function (data) {
            return {
                source: "".concat(data.f13, ".").concat(data.f12),
                txt: data.f12,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12), target: "_blank" }, data.f12),
                color: '',
            };
        }
    },
    _a[QuoteItem.市场] = {
        fid: ['f13'],
        sort: 'f13',
        value: function (data) {
            return {
                txt: data.f13,
                html: react_1.default.createElement("span", null, data.f13),
                color: '',
                source: data.f13
            };
        }
    },
    _a[QuoteItem.证券类型] = {
        fid: ['f19'],
        sort: 'f19',
        value: function (data) {
            return {
                txt: data.f19,
                html: react_1.default.createElement("span", null, data.f19),
                color: '',
                source: data.f19
            };
        }
    },
    _a[QuoteItem.行情代码] = {
        fid: ['f12', 'f13'],
        sort: 'f12',
        value: function (data) {
            return {
                txt: data.f13 + '.' + data.f12,
                html: react_1.default.createElement("span", null, data.f13 + '.' + data.f12),
                color: '',
                source: data.f13 + '.' + data.f12
            };
        }
    },
    _a[QuoteItem.行情统一链接] = {
        fid: ['f12', 'f13', 'f14'],
        sort: 'f14',
        value: function (data) {
            return {
                source: "".concat(data.f13, ".").concat(data.f12),
                txt: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12),
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12), title: data.f14, target: "_blank" }, data.f14),
                color: '',
            };
        }
    },
    _a[QuoteItem.板块链接] = {
        fid: ['f12', 'f13', 'f14'],
        sort: 'f14',
        value: function (data) {
            return {
                source: "".concat(data.f13, ".").concat(data.f12),
                txt: "gridlist.html#boards2-".concat(data.f13, ".").concat(data.f12),
                html: react_1.default.createElement("a", { href: "gridlist.html#boards2-".concat(data.f13, ".").concat(data.f12), target: "_blank" }, data.f14),
                color: '',
            };
        }
    },
    _a[QuoteItem.新三板行情统一链接] = {
        fid: ['f12', 'f13', 'f14', 'f111'],
        sort: 'f14',
        value: function (data) {
            return {
                source: '',
                txt: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12),
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12), target: "_blank" },
                    xinSanBanIcon(data.f111),
                    " ",
                    xinSanBanIcon2(data.f111),
                    " ",
                    data.f14),
                color: '',
            };
        }
    },
    _a[QuoteItem.最新价] = {
        fid: ['f1', 'f2', 'f4'],
        sort: 'f2',
        value: function (data) {
            return quoteItem(data.f2, data.f1, data.f4, -1);
        }
    },
    _a[QuoteItem.涨跌幅] = {
        fid: ['f3', 'f152', 'f4'],
        sort: 'f3',
        value: function (data) {
            return quoteItem(data.f3, data.f152, data.f4, -1, '%');
        }
    },
    _a[QuoteItem.涨跌额] = {
        fid: ['f1', 'f4'],
        sort: 'f4',
        value: function (data) {
            return quoteItem(data.f4, data.f1, data.f4, -1);
        }
    },
    _a[QuoteItem.今开价] = {
        fid: ['f17', 'f1', 'f18'],
        sort: 'f17',
        value: function (data) {
            return quoteItem(data.f17, data.f1, data.f17 - data.f18, -1);
        }
    },
    _a[QuoteItem.今开价用昨结计算] = {
        fid: ['f17', 'f1', 'f28'],
        sort: 'f17',
        value: function (data) {
            return quoteItem(data.f17, data.f1, data.f17 - data.f28, -1);
        }
    },
    _a[QuoteItem.昨收价] = {
        fid: ['f18', 'f1'],
        sort: 'f18',
        value: function (data) {
            return quoteItem(data.f18, data.f1, 0, -1);
        }
    },
    _a[QuoteItem.昨结] = {
        fid: ['f28', 'f1'],
        sort: 'f28',
        value: function (data) {
            return quoteItem(data.f28, data.f1, 0, -1);
        }
    },
    _a[QuoteItem.最高价] = {
        fid: ['f15', 'f1', 'f18'],
        sort: 'f15',
        value: function (data) {
            return quoteItem(data.f15, data.f1, data.f15 - data.f18, -1);
        }
    },
    _a[QuoteItem.最高价用昨结计算] = {
        fid: ['f15', 'f1', 'f28'],
        sort: 'f15',
        value: function (data) {
            return quoteItem(data.f15, data.f1, data.f15 - data.f28, -1);
        }
    },
    _a[QuoteItem.最低价] = {
        fid: ['f16', 'f1', 'f18'],
        sort: 'f16',
        value: function (data) {
            return quoteItem(data.f16, data.f1, data.f16 - data.f18, -1);
        }
    },
    _a[QuoteItem.最低价用昨结计算] = {
        fid: ['f16', 'f1', 'f28'],
        sort: 'f16',
        value: function (data) {
            return quoteItem(data.f16, data.f1, data.f16 - data.f28, -1);
        }
    },
    _a[QuoteItem.总市值] = {
        fid: ['f20'],
        sort: 'f20',
        value: function (data) {
            return quoteItem(data.f20, -1, 0, 4);
        }
    },
    _a[QuoteItem.流通市值] = {
        fid: ['f21'],
        sort: 'f21',
        value: function (data) {
            return quoteItem(data.f21, -1, 0, 4);
        }
    },
    _a[QuoteItem.净利润] = {
        fid: ['f45'],
        sort: 'f45',
        value: function (data) {
            return quoteItem(data.f45, -1, 0, 4);
        }
    },
    _a[QuoteItem.市盈率动态] = {
        fid: ['f9', 'f152'],
        sort: 'f9',
        value: function (data) {
            if (data.f9 == 0)
                return quoteItem('-', data.f152, 0, -1);
            return quoteItem(data.f9, data.f152, 0, -1);
        }
    },
    _a[QuoteItem.市盈率TTM] = {
        fid: ['f115', 'f152'],
        sort: 'f115',
        value: function (data) {
            if (data.f115 == 0)
                return quoteItem('-', data.f152, 0, -1);
            return quoteItem(data.f115, data.f152, 0, -1);
        }
    },
    _a[QuoteItem.成交量] = {
        fid: ['f5'],
        sort: 'f5',
        value: function (data) {
            return quoteItem(data.f5, -1, 0, 4, "", 2);
            // return quoteItem(data.f6, -1, 0, 4)
        }
    },
    _a[QuoteItem.成交额] = {
        fid: ['f6'],
        sort: 'f6',
        value: function (data) {
            return quoteItem(data.f6, -1, 0, 4, "", 2);
            // return quoteItem(data.f6, -1, 0, 4)
        }
    },
    _a[QuoteItem.内盘_卖盘] = {
        fid: ['f35'],
        sort: 'f35',
        value: function (data) {
            return quoteItem(data.f35, -1, 0, 4);
        }
    },
    _a[QuoteItem.外盘_买盘] = {
        fid: ['f34'],
        sort: 'f34',
        value: function (data) {
            return quoteItem(data.f34, -1, 0, 4);
        }
    },
    _a[QuoteItem.振幅] = {
        fid: ['f7', 'f152'],
        sort: 'f7',
        value: function (data) {
            return quoteItem(data.f7, data.f152, 0, -1, '%');
        }
    },
    _a[QuoteItem.量比] = {
        fid: ['f10', 'f152'],
        sort: 'f10',
        value: function (data) {
            return quoteItem(data.f10, data.f152, 0, -1);
        }
    },
    _a[QuoteItem.换手率] = {
        fid: ['f8', 'f152'],
        sort: 'f8',
        value: function (data) {
            return quoteItem(data.f8, data.f152, 0, -1, '%');
        }
    },
    _a[QuoteItem.市净率] = {
        fid: ['f23', 'f152'],
        sort: 'f23',
        value: function (data) {
            return quoteItem(data.f23, data.f152, 0, -1);
        }
    },
    _a[QuoteItem.委比] = {
        fid: ['f33', 'f152'],
        sort: 'f33',
        value: function (data) {
            if (data.f33 == 0)
                data.f33 = '-';
            return quoteItem(data.f33, data.f152, data.f33, -1, '%');
        }
    },
    _a[QuoteItem.交易时间] = {
        fid: ['f124'],
        sort: 'f124',
        value: function (data) {
            return {
                txt: transTradeTime(data.f124, false, false),
                html: react_1.default.createElement("span", null, transTradeTime(data.f124, false, false)),
                color: '',
                source: data.f124
            };
        }
    },
    _a[QuoteItem.持仓量] = {
        fid: ['f108'],
        sort: 'f108',
        value: function (data) {
            return quoteItem(data.f108, -1, 0, 4);
        }
    },
    _a[QuoteItem.买量] = {
        fid: ['f211'],
        sort: 'f211',
        value: function (data) {
            return quoteItem(data.f211, -1, 0, 4);
        }
    },
    _a[QuoteItem.卖量] = {
        fid: ['f212'],
        sort: 'f212',
        value: function (data) {
            return quoteItem(data.f212, -1, 0, 4);
        }
    },
    _a[QuoteItem.买入价或买一价] = {
        fid: ['f31', 'f1'],
        sort: 'f31',
        value: function (data) {
            return quoteItem(data.f31, data.f1, 0, -1);
        }
    },
    _a[QuoteItem.卖出价或卖一价] = {
        fid: ['f32', 'f1'],
        sort: 'f32',
        value: function (data) {
            return quoteItem(data.f32, data.f1, 0, -1);
        }
    },
    _a[QuoteItem.买二价] = {
        fid: ['f142', 'f1'],
        sort: 'f142',
        value: function (data) {
            return quoteItem(data.f142, data.f1, 0, -1);
        }
    },
    _a[QuoteItem.卖二价] = {
        fid: ['f143', 'f1'],
        sort: 'f143',
        value: function (data) {
            return quoteItem(data.f143, data.f1, 0, -1);
        }
    },
    _a[QuoteItem.涨跌幅_5分钟] = {
        fid: ['f11', 'f152'],
        sort: 'f11',
        value: function (data) {
            return quoteItem(data.f11, data.f152, data.f11, -1, '%');
        }
    },
    _a[QuoteItem.涨跌幅_60日] = {
        fid: ['f24', 'f152'],
        sort: 'f24',
        value: function (data) {
            return quoteItem(data.f24, data.f152, data.f24, -1, '%');
        }
    },
    _a[QuoteItem.年初至今涨跌幅] = {
        fid: ['f25', 'f152'],
        sort: 'f25',
        value: function (data) {
            return quoteItem(data.f25, data.f152, data.f25, -1, '%');
        }
    },
    _a[QuoteItem.涨速_3分钟] = {
        fid: ['f22', 'f152'],
        sort: 'f22',
        value: function (data) {
            return quoteItem(data.f22, data.f152, data.f22, -1, '%');
        }
    },
    _a[QuoteItem.主力净流入] = {
        fid: ['f62'],
        sort: 'f62',
        value: function (data) {
            return quoteItem(data.f62, -1, data.f62, 4);
        }
    },
    _a[QuoteItem.板块领涨股] = {
        fid: ['f128', 'f140', 'f141'],
        sort: 'f128',
        value: function (data) {
            return {
                source: data.f128,
                txt: data.f128,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f141, ".").concat(data.f140), target: "_blank" }, data.f128),
                color: '',
            };
        }
    },
    _a[QuoteItem.板块领涨股涨跌幅] = {
        fid: ['f136'],
        sort: 'f136',
        value: function (data) {
            return quoteItem(data.f136, 2, data.f136, -1, '%');
        }
    },
    _a[QuoteItem.板块领跌股] = {
        fid: ['f207', 'f208', 'f209'],
        sort: 'f207',
        value: function (data) {
            return {
                source: data.f207,
                txt: data.f207,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f209, ".").concat(data.f208), target: "_blank" }, data.f207),
                color: ''
            };
        }
    },
    _a[QuoteItem.板块领跌股涨跌幅] = {
        fid: ['f222'],
        sort: 'f222',
        value: function (data) {
            return quoteItem(data.f222, 2, data.f222, -1, '%');
        }
    },
    _a[QuoteItem.涨跌家数] = {
        fid: ['f104', 'f105'],
        sort: 'f104',
        value: function (data) {
            return {
                source: data.f104,
                txt: data.f104 + '/' + data.f105,
                html: react_1.default.createElement("span", null,
                    react_1.default.createElement("span", { className: "price_up" }, data.f104),
                    "/",
                    react_1.default.createElement("span", { className: "price_down" }, data.f105)),
                color: '',
            };
        }
    },
    _a[QuoteItem.板块或指数上涨数量] = {
        fid: ['f104'],
        sort: 'f104',
        value: function (data) {
            return {
                source: data.f104,
                txt: data.f104,
                html: react_1.default.createElement("span", { className: "price_up" }, data.f104),
                color: '',
            };
        }
    },
    _a[QuoteItem.板块或指数下跌数量] = {
        fid: ['f105'],
        sort: 'f105',
        value: function (data) {
            return {
                source: data.f105,
                txt: data.f105,
                html: react_1.default.createElement("span", { className: "price_down" }, data.f105),
                color: '',
            };
        }
    },
    _a[QuoteItem.板块或指数平数量] = {
        fid: ['f106'],
        sort: 'f106',
        value: function (data) {
            return {
                source: data.f106,
                txt: data.f106,
                html: react_1.default.createElement("span", null, data.f106),
                color: '',
            };
        }
    },
    _a[QuoteItem.主力净占比] = {
        fid: ['f184', 'f152'],
        sort: 'f184',
        value: function (data) {
            return quoteItem(data.f184, data.f152, data.f184, -1, '%');
        }
    },
    _a[QuoteItem.主力净占比_排名] = {
        fid: ['f225'],
        sort: 'f225',
        value: function (data) {
            return quoteItem(data.f225, -1, 0, -1);
        }
    },
    _a[QuoteItem.主力净占比_排名变化] = {
        fid: ['f226'],
        sort: 'f226',
        value: function (data) {
            return quoteItem(data.f226, -1, data.f226, -1);
        }
    },
    _a[QuoteItem.板块资金流入最大股] = {
        fid: ['f204', 'f205', 'f206'],
        sort: 'f204',
        value: function (data) {
            return {
                source: data.f204,
                txt: data.f204,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f206, ".").concat(data.f205), target: "_blank" }, data.f204),
                color: ''
            };
        }
    },
    _a[QuoteItem.上市日期] = {
        fid: ['f26'],
        sort: 'f26',
        value: function (data) {
            return {
                txt: dealSSRQ(data.f26),
                html: react_1.default.createElement("span", null, dealSSRQ(data.f26)),
                color: '',
                source: data.f26
            };
        }
    },
    _a[QuoteItem.AB股对应的名称] = {
        sort: 'f203',
        fid: ['f203', 'f201', 'f202'],
        value: function (data) {
            return {
                txt: data.f203,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f202, ".").concat(data.f201) }, data.f203),
                color: '',
                source: data.f203
            };
        }
    },
    _a[QuoteItem.AB股对应的市场] = {
        fid: ['f202'],
        sort: 'f202',
        value: function (data) {
            return {
                txt: data.f202,
                source: data.f202,
                html: react_1.default.createElement("span", null, data.f202),
                color: ''
            };
        }
    },
    _a[QuoteItem.AB股对应的代码] = {
        fid: ['f201', 'f202', 'f203'],
        sort: 'f201',
        value: function (data) {
            return {
                txt: data.f201,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f202, ".").concat(data.f201) }, data.f201),
                color: '',
                source: data.f201
            };
        }
    },
    _a[QuoteItem.AB股对应的最新价] = {
        fid: ['f196', 'f200', 'f197'],
        sort: 'f196',
        value: function (data) {
            return quoteItem(data.f196, data.f200, data.f197, -1);
        }
    },
    _a[QuoteItem.AB股对应的涨跌幅] = {
        fid: ['f197', 'f152'],
        sort: 'f197',
        value: function (data) {
            return quoteItem(data.f197, data.f152, data.f197, -1, '%');
        }
    },
    _a[QuoteItem.AB股比价] = {
        fid: ['f199', 'f152'],
        sort: 'f199',
        value: function (data) {
            return quoteItem(data.f199, data.f152, 0, -1);
        }
    },
    _a[QuoteItem.H股对应的A股代码] = {
        fid: ['f192', 'f191'],
        sort: 'f191',
        value: function (data) {
            return {
                txt: data.f191,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f192, ".").concat(data.f191) }, data.f191),
                color: '',
                source: data.f191
            };
        }
    },
    _a[QuoteItem.H股对应的A股最新价] = {
        fid: ['f186', 'f190', 'f187'],
        sort: 'f186',
        value: function (data) {
            return quoteItem(data.f186, data.f190, data.f187, -1);
        }
    },
    _a[QuoteItem.H股对应的A股市场] = {
        fid: ['192'],
        sort: '192',
        value: function (data) {
            return {
                txt: data.f192,
                source: data.f192,
                html: react_1.default.createElement("span", null, data.f192),
                color: ''
            };
        }
    },
    _a[QuoteItem.H股对应的A股行情统一链接] = {
        sort: 'f193',
        fid: ['f193', 'f191', 'f192'],
        value: function (data) {
            return {
                txt: data.f193,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f192, ".").concat(data.f191) }, data.f193),
                color: '',
                source: data.f192 + '.' + data.f193
            };
        }
    },
    _a[QuoteItem.H股对应的A股涨跌幅] = {
        fid: ['f187', 'f152'],
        sort: 'f187',
        value: function (data) {
            return quoteItem(data.f187, data.f152, data.f187, -1, '%');
        }
    },
    _a[QuoteItem.AH股比价] = {
        fid: ['f189', 'f152'],
        sort: 'f189',
        value: function (data) {
            return quoteItem(data.f189, data.f152, 0, -1);
        }
    },
    _a[QuoteItem.AH股溢价] = {
        fid: ['f188', 'f152'],
        sort: 'f188',
        value: function (data) {
            var color = data.f188 > 0 ? 1 : data.f188 < 0 ? -1 : 0;
            return quoteItem(data.f188, data.f152, color, -1);
        }
    },
    _a[QuoteItem.带交易状态的名称] = {
        fid: ['f12', 'f13', 'f14', 'f292'],
        sort: "f14",
        value: function (data) {
            var open = [1, 2, 4].indexOf(data.f292) > -1, icon = open ? "icon_trading" : "closetrade";
            return {
                source: "".concat(data.f14),
                txt: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12),
                html: react_1.default.createElement("span", null,
                    react_1.default.createElement("em", { className: icon }),
                    react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f12), target: "_blank" }, data.f14)),
                color: '',
            };
        }
    },
    _a[QuoteItem.可转债对应的正股代码] = {
        fid: ['f232', 'f233'],
        sort: 'f232',
        value: function (data) {
            return {
                txt: data.f232,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f233, ".").concat(data.f232) }, data.f232),
                color: '',
                source: data.f232
            };
        }
    },
    _a[QuoteItem.可转债对应的正股名称] = {
        fid: ['f232', 'f233', 'f234'],
        sort: 'f234',
        value: function (data) {
            return {
                txt: data.f234,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f233, ".").concat(data.f232) }, data.f234),
                color: '',
                source: data.f234
            };
        }
    },
    _a[QuoteItem.可转债对应的正股最新价] = {
        fid: ['f229', 'f230', 'f231'],
        sort: 'f229',
        value: function (data) {
            return quoteItem(data.f229, data.f231, data.f230, -1);
        }
    },
    _a[QuoteItem.可转债对应的正股涨跌幅] = {
        fid: ['f152', 'f229', 'f230', 'f231'],
        sort: 'f230',
        value: function (data) {
            return quoteItem(data.f230, data.f152, data.f230, -1, '%');
        }
    },
    _a[QuoteItem.可转债转股价] = {
        fid: ['f235', 'f231'],
        sort: 'f235',
        value: function (data) {
            return quoteItem(data.f235, data.f231, 0, -1);
        }
    },
    _a[QuoteItem.可转债转股价值] = {
        fid: ['f236', 'f154'],
        sort: 'f236',
        value: function (data) {
            return quoteItem(data.f236, data.f154, 0, -1);
        }
    },
    _a[QuoteItem.可转债转股溢价率] = {
        fid: ['f237', 'f152'],
        sort: 'f237',
        value: function (data) {
            return quoteItem(data.f237, data.f152, data.f237, -1, '%');
        }
    },
    _a[QuoteItem.可转债纯债溢价率] = {
        fid: ['f238', 'f152'],
        sort: 'f238',
        value: function (data) {
            return quoteItem(data.f238, data.f152, data.f238, -1, '%');
        }
    },
    _a[QuoteItem.可转债回售触发价] = {
        fid: ['f239', 'f231'],
        sort: 'f239',
        value: function (data) {
            return quoteItem(data.f239, data.f231, 0, -1);
        }
    },
    _a[QuoteItem.可转债强赎触发价] = {
        fid: ['f240', 'f231'],
        sort: 'f240',
        value: function (data) {
            return quoteItem(data.f240, data.f231, 0, -1);
        }
    },
    _a[QuoteItem.可转债到期赎回价] = {
        fid: ['f241', 'f231'],
        sort: 'f241',
        value: function (data) {
            return quoteItem(data.f241, data.f231, 0, -1);
        }
    },
    _a[QuoteItem.可转债纯债价值] = {
        fid: ['f227', 'f154'],
        sort: 'f227',
        value: function (data) {
            return quoteItem(data.f227, data.f154, 0, -1);
        }
    },
    _a[QuoteItem.可转债开始转股日] = {
        fid: ['f242'],
        sort: 'f242',
        value: function (data) {
            return {
                txt: dealSSRQ(data.f242),
                html: react_1.default.createElement("span", null, dealSSRQ(data.f242)),
                color: '',
                source: data.f242
            };
        }
    },
    _a[QuoteItem.可转债申购日] = {
        fid: ['f243'],
        sort: 'f243',
        value: function (data) {
            return {
                txt: dealSSRQ(data.f243),
                html: react_1.default.createElement("span", null, dealSSRQ(data.f243)),
                color: '',
                source: data.f243
            };
        }
    },
    _a[QuoteItem.ADR代码带链接] = {
        fid: ['f213', 'f214'],
        sort: 'f213',
        value: function (data) {
            return {
                source: '',
                txt: data.f213,
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f214, ".").concat(data.f213), target: "_blank" }, data.f213),
                color: '',
            };
        }
    },
    _a[QuoteItem.ADR收市价] = {
        fid: ['f219', 'f216', 'f217'],
        sort: 'f219',
        value: function (data) {
            return quoteItem(data.f219, data.f216, data.f217, -1);
        }
    },
    _a[QuoteItem.ADR折合每股港元] = {
        fid: ['f220', 'f216'],
        sort: 'f220',
        value: function (data) {
            return quoteItem(data.f220, data.f216, 0, -1);
        }
    },
    _a[QuoteItem.ADR涨跌额] = {
        fid: ['f217', 'f216',],
        sort: 'f217',
        value: function (data) {
            return quoteItem(data.f217, data.f216, data.f217, -1);
        }
    },
    _a[QuoteItem.ADR涨跌幅] = {
        fid: ['f218', 'f152'],
        sort: 'f218',
        value: function (data) {
            return quoteItem(data.f218, data.f152, data.f218, -1, '%');
        }
    },
    _a[QuoteItem.期权最新价] = {
        fid: ['f1', 'f2', 'f4'],
        sort: 'f2',
        value: function (data) {
            return quoteItem(data.f2, data.f1, data.f4, -1);
        }
    },
    _a[QuoteItem.期权涨跌幅] = {
        fid: ['f3', 'f152', 'f4'],
        sort: 'f3',
        value: function (data) {
            return quoteItem(data.f3, data.f152, data.f4, -1, '%');
        }
    },
    _a[QuoteItem.期权涨跌额] = {
        fid: ['f1', 'f4'],
        sort: 'f4',
        value: function (data) {
            return quoteItem(data.f4, data.f1, data.f4, -1);
        }
    },
    _a[QuoteItem.期权行权价] = {
        fid: ['f161', 'f330'],
        sort: 'f161',
        value: function (data) {
            return quoteItem(data.f161, data.f330, 0, -1);
        }
    },
    _a[QuoteItem.期权T型报价行权价] = {
        fid: ['f161', 'f330'],
        sort: 'f161',
        value: function (data) {
            return quoteItem(data.f161, data.f330, 0, -1, "");
        }
    },
    _a[QuoteItem.期权剩余期限] = {
        fid: ['f162'],
        sort: 'f162',
        value: function (data) {
            return quoteItem(data.f162, -1, 0, -1);
        }
    },
    _a[QuoteItem.期货日增] = {
        fid: ['f163'],
        sort: 'f163',
        value: function (data) {
            return quoteItem(data.f163, -1, data.f163, -1);
        }
    },
    _a[QuoteItem.期货今开] = {
        fid: ['f17', 'f1', 'f28'],
        sort: 'f17',
        value: function (data) {
            return quoteItem(data.f17, data.f1, data.f17 - data.f28, -1);
        }
    },
    _a[QuoteItem.期权隐含波动率] = {
        fid: ['f249', 'f152'],
        sort: 'f249',
        value: function (data) {
            return quoteItem(data.f249, data.f152, 0, -1, '%');
        }
    },
    _a[QuoteItem.期权折溢价率] = {
        fid: ['f250', 'f152'],
        sort: 'f250',
        value: function (data) {
            return quoteItem(data.f250, data.f152, 0, -1, '%');
        }
    },
    _a[QuoteItem.认沽认购期权名称] = {
        fid: ['f340', 'f13', 'f339'],
        sort: 'f340',
        value: function (data) {
            return {
                source: "".concat(data.f13, ".").concat(data.f339),
                txt: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f339),
                html: react_1.default.createElement("a", { href: "//quote.eastmoney.com/unify/r/".concat(data.f13, ".").concat(data.f339), target: "_blank" }, data.f340),
                color: '',
            };
        }
    },
    _a[QuoteItem.期权标的券最新价] = {
        fid: ['f334', 'f330'],
        sort: 'f334',
        value: function (data) {
            return quoteItem(data.f334, data.f330, 0, -1);
        }
    },
    _a[QuoteItem.认沽认购期权最新价] = {
        fid: ['f341', 'f1', 'f342'],
        sort: 'f341',
        value: function (data) {
            return quoteItem(data.f341, data.f1, data.f342, -1, "");
        }
    },
    _a[QuoteItem.认沽认购期权涨跌幅] = {
        fid: ['f343', 'f152'],
        sort: 'f343',
        value: function (data) {
            return quoteItem(data.f343, data.f152, data.f343, -1, '%');
        }
    },
    _a[QuoteItem.认沽认购期权涨跌额] = {
        fid: ['f342', 'f1'],
        sort: 'f342',
        value: function (data) {
            return quoteItem(data.f342, data.f1, data.f342, -1);
        }
    },
    _a[QuoteItem.认沽认购期权成交量] = {
        fid: ['f344'],
        sort: 'f344',
        value: function (data) {
            return quoteItem(data.f344, -1, 0, 4, "", 2);
            // return quoteItem(data.f6, -1, 0, 4)
        }
    },
    _a[QuoteItem.认沽认购期权持仓量] = {
        fid: ['f345'],
        sort: 'f345',
        value: function (data) {
            return quoteItem(data.f345, -1, 0, 4, "", 2);
            // return quoteItem(data.f6, -1, 0, 4)
        }
    },
    _a[QuoteItem.认沽认购期权隐含波动率] = {
        fid: ['f346', 'f152'],
        sort: 'f346',
        value: function (data) {
            return quoteItem(data.f346, data.f152, 0, -1, '%');
        }
    },
    _a[QuoteItem.认沽认购期权折溢价率] = {
        fid: ['f347', 'f152'],
        sort: 'f347',
        value: function (data) {
            return quoteItem(data.f347, data.f152, 0, -1, '%');
        }
    },
    _a);
/**
 * 转化行情数据为需要的格式
 * @param input 输入数据
 * @param fixed 缩小倍数并保留小数位数
 * @param colornumber 颜色 大于0红色 小于0 绿色 等于0 灰色 null不设置颜色
 * @param format_number 格式化数据 万 亿 万亿 并设置最大宽度
 * @param hz 后缀
 * @param tofixed 保留小数位数
 * @returns
 */
function quoteItem(input, fixed, colornumber, format_number, hz, tofixed, fixed_tofixed) {
    if (input == undefined) {
        return {
            txt: '',
            color: '',
            html: react_1.default.createElement(react_1.default.Fragment, null, "-"),
            source: input
        };
    }
    if (input == '-') {
        return {
            txt: '-',
            color: '',
            html: react_1.default.createElement(react_1.default.Fragment, null, "-"),
            source: input
        };
    }
    var return_obj = {
        txt: input.toString(),
        color: 'price_draw',
        html: react_1.default.createElement(react_1.default.Fragment, null),
        source: input
    };
    //处理放大倍数
    if (typeof input == 'number' && fixed > 0) {
        return_obj.txt = (input / (Math.pow(10, fixed))).toFixed(fixed);
    }
    if (typeof input == 'number' && tofixed != undefined && tofixed > 0) {
        return_obj.txt = input.toFixed(tofixed);
    }
    if (typeof input == 'number' && fixed > 0 && fixed_tofixed != undefined && fixed_tofixed > 0) {
        return_obj.txt = (input / (Math.pow(10, fixed))).toFixed(fixed_tofixed);
    }
    //格式化
    if (typeof input == 'number' && format_number > 0) {
        return_obj.txt = formatNumMaxWidth(input, format_number, tofixed);
    }
    //颜色
    if (colornumber != null && colornumber > 0) {
        return_obj.color = 'price_up';
    }
    else if (colornumber != null && colornumber < 0) {
        return_obj.color = 'price_down';
    }
    else if (colornumber != null && colornumber == 0) {
        return_obj.color = 'price_draw';
    }
    else {
        return_obj.color = '';
    }
    //后缀
    if (hz != undefined) {
        return_obj.txt += hz;
    }
    return_obj.html = react_1.default.createElement("span", { className: return_obj.color }, return_obj.txt);
    return return_obj;
}
exports.quoteItem = quoteItem;
/**
 * 控制宽度的格式化数字
 * @param num
 * @param tofixed 指定保留小数位
*/
function formatNumMaxWidth(num, maxwidth, tofixed) {
    if (maxwidth < 0) {
        return num;
    }
    if (isNaN(num) || num === '') {
        return num;
    }
    var hz = '';
    if (num >= 1000000000000 || num <= -1000000000000) {
        num = num / 1000000000000;
        hz = '万亿';
    }
    if (num >= 100000000 || num <= -100000000) {
        num = num / 100000000;
        hz = '亿';
    }
    else if (num >= 10000 || num <= -10000) {
        num = num / 10000;
        hz = '万';
    }
    //整数部分长度
    var zs_length = num.toString().indexOf('.');
    if (num.toString().indexOf('-') == 0)
        zs_length--; //如果是负数，整数部分长度减1
    if (zs_length < 0) {
        return num + hz;
    }
    var fixed = maxwidth - zs_length;
    if (fixed < 0)
        fixed = 0;
    if (tofixed)
        fixed = tofixed;
    var tonum = num.toFixed(fixed);
    // if(tonum.endsWith('000')){
    //   tonum  = num.toFixed(fixed + 3)
    // }
    // else if(tonum.endsWith('00')){
    //   tonum  = num.toFixed(fixed + 2)
    // }
    // else if(tonum.endsWith('0')){
    //   tonum  = num.toFixed(fixed + 1)
    // }
    return tonum + hz;
}
exports.formatNumMaxWidth = formatNumMaxWidth;
/**
 *
 * @param f111 新三板图标 创新层 基础层
 */
function xinSanBanIcon(f111) {
    if (f111 & 256) {
        //基础层
        return react_1.default.createElement("span", { className: "icon_xsb_j", title: "\u57FA\u7840\u5C42" });
    }
    else if (f111 & 512) {
        //创新层 
        return react_1.default.createElement("span", { className: "icon_xsb_c", title: "\u521B\u65B0\u5C42" });
    }
    return react_1.default.createElement("span", { className: "icon_xsb_blank" });
}
/**
 *
 * @param f111 新三板图标 集合竞价 做市交易
 */
function xinSanBanIcon2(f111) {
    if (f111 & 32) {
        //做市交易
        return react_1.default.createElement("span", { className: "icon_xsb_s", title: "\u505A\u5E02\u4EA4\u6613" });
    }
    else if (f111 & 128) {
        //集合竞价
        return react_1.default.createElement("span", { className: "icon_xsb_ji", title: "\u96C6\u5408\u7ADE\u4EF7" });
    }
    return react_1.default.createElement("span", { className: "icon_xsb_blank" });
}
/**
 * 处理交易时间
 * @param trade_time 输入行情时间
 * @param showxq 是否显示星期
 * @param showkh 是否显示括号
 * @returns
 */
function transTradeTime(trade_time, showxq, showkh) {
    if (showxq === void 0) { showxq = false; }
    if (showkh === void 0) { showkh = true; }
    if (isNaN(trade_time)) {
        return '-';
    }
    try {
        var d = new Date(trade_time * 1000);
        var xq = '';
        if (showxq) {
            switch (d.getDay()) {
                case 0:
                    xq = ' 星期日';
                    break;
                case 1:
                    xq = ' 星期一';
                    break;
                case 2:
                    xq = ' 星期二';
                    break;
                case 3:
                    xq = ' 星期三';
                    break;
                case 4:
                    xq = ' 星期四';
                    break;
                case 5:
                    xq = ' 星期五';
                    break;
                case 6:
                    xq = ' 星期六';
                    break;
            }
        }
        var jysj = d.getFullYear() + '-' + (("0" + (d.getMonth() + 1)).slice(-2)) + '-' + (("0" + (d.getDate())).slice(-2)) + xq + ' ' + ("0" + (d.getHours())).slice(-2) + ':' + ("0" + (d.getMinutes())).slice(-2) + ':' + ("0" + (d.getSeconds())).slice(-2);
        if (showkh)
            return '（' + jysj + '）';
        return jysj;
    }
    catch (e) {
        return '-';
    }
}
exports.transTradeTime = transTradeTime;
/**
 * 处理上市日期
 */
function dealSSRQ(ssrq) {
    if (ssrq > 0 && ssrq.toString().length > 7) {
        ssrq = ssrq.toString();
        return ssrq.substring(0, 4) + '-' + ssrq.substring(4, 6) + '-' + ssrq.substring(6, 8);
    }
    return ssrq;
}
